<div class="white-box border-radius p-4 mt-4 mx-4">
	<div class="d-flex align-items-center justify-content-between mb-3">
		<h5 class="mb-0">{{ title }}</h5>
		<button *ngIf="isActive" class="btn btn-primary" (click)="showNewStudyForm = true">{{ 'studies.create_new_study' | translate }}</button>
	</div>

	<div class="row align-items-end mb-4">
		<div class="col-md-6">
			<h6>{{ 'studies.filter_by_date' | translate }}</h6>
			<app-date-range-select
				[withBorder]="false"
				[activePage]="'events'"
				(onDatesChanged)="onDatesChanged($event)"
			></app-date-range-select>
		</div>
		<div class="col-md-3">
			<h6>{{ 'studies.filter_by_sn' | translate }}</h6>
			<ng-select
				[items]="snOptions"
				bindLabel="value"
				bindValue="id"
				[clearable]="false"
				[searchable]="true"
				[(ngModel)]="selectedSN"
				(ngModelChange)="onSnFilterChange()"
			></ng-select>
		</div>
	</div>
	<div class="text-danger" *ngIf="invalidDateRange">
		<b>{{ 'g.start_lg_end' | translate }}</b>
	</div>

	<sct-custom-table
		[columnsConfig]="listingColumns"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>

<app-modal #locationModal [title]="'g.locations' | translate" size="lg" [hasConfirmButton]="false">
	<app-mapbox-search
		*ngIf="selectedLocation && isShownMap"
		class="border-radius main-blue-border"
		[latitude]="sitesService.defaultMapLocation.latitude"
		[longitude]="sitesService.defaultMapLocation.longitude"
		zoom="3.5"
		dotsType="mix"
		[dots]="selectedLocation"
		[showPopup]="false"
	></app-mapbox-search>
</app-modal>

<app-new-study
	*ngIf="showNewStudyForm"
	[parent]="'admin'"
	[studies]="allStudies"
	(onClose)="onNewStudyFormClose($event)"
></app-new-study>

<app-new-study
	*ngIf="showEditStudyForm"
	[editMode]="true"
	[editStudyData]="editStudyData"
	(onClose)="onEditStudyFormClose($event)"
></app-new-study>
